import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="Footer">
      <div className="container">
        <div className="Footer__TitleBar">
          <Link to="/">
            <h1 className="Footer__TitleBar__Title">
              JTV Suriname
            </h1>
          </Link>
        </div>
      </div>
      <div className="Footer__Bar" />
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js